// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "inference/v1/inference.proto" (package "inference.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal APIs for running LLM inference
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message inference.v1.InferQueryRequest
 */
export interface InferQueryRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string user_prompt = 2;
     */
    userPrompt: string;
    /**
     * The user's existing MQL query, if it exists
     *
     * @generated from protobuf field: string user_mql_query = 3;
     */
    userMqlQuery: string;
    /**
     * A stringified and masked list of sample documents to build provide the assistant
     *
     * @generated from protobuf field: string sample_documents = 4;
     */
    sampleDocuments: string;
    /**
     * The conversation history
     *
     * @generated from protobuf field: string conversation_history = 5;
     */
    conversationHistory: string;
    /**
     * The currently selected tab: "mql" or "sql"
     *
     * @generated from protobuf field: string selected_tab = 6;
     */
    selectedTab: string;
    /**
     * The user's existing SQL query, if it exists
     *
     * @generated from protobuf field: string user_sql_query = 7;
     */
    userSqlQuery: string;
}
/**
 * @generated from protobuf message inference.v1.InferQueryResponse
 */
export interface InferQueryResponse {
    /**
     * The assistant's message response
     *
     * @generated from protobuf field: string assistant_response = 1;
     */
    assistantResponse: string;
    /**
     * The assistant's structured response
     *
     * @generated from protobuf field: string structured_response = 2;
     */
    structuredResponse: string;
    /**
     * The type of structured response
     *
     * @generated from protobuf field: string structured_response_type = 3;
     */
    structuredResponseType: string;
}
/**
 * One turn in a multi-turn conversation with the AI code assistant.
 *
 * @generated from protobuf message inference.v1.ConversationTurn
 */
export interface ConversationTurn {
    /**
     * @generated from protobuf field: inference.v1.ConversationRole role = 1;
     */
    role: ConversationRole;
    /**
     * @generated from protobuf field: string content = 2;
     */
    content: string;
}
/**
 * @generated from protobuf message inference.v1.InferModuleCodeRequest
 */
export interface InferModuleCodeRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string module_name = 2;
     */
    moduleName: string;
    /**
     * @generated from protobuf field: string user_prompt = 3;
     */
    userPrompt: string;
    /**
     * The current module code content for code improvement requests
     *
     * @generated from protobuf field: string code_content = 4;
     */
    codeContent: string;
    /**
     * The programming language of the code (e.g., "python", "go")
     *
     * @generated from protobuf field: string programming_language = 5;
     */
    programmingLanguage: string;
    /**
     * Prior turns in this conversation session (user/assistant pairs), oldest first.
     *
     * @generated from protobuf field: repeated inference.v1.ConversationTurn conversation_history = 6;
     */
    conversationHistory: ConversationTurn[];
    /**
     * Session ID for an existing conversation; omit to start a new one.
     *
     * @generated from protobuf field: string conversation_id = 7;
     */
    conversationId: string;
}
/**
 * @generated from protobuf message inference.v1.InferModuleCodeResponse
 */
export interface InferModuleCodeResponse {
    /**
     * The assistant's message response
     *
     * @generated from protobuf field: string assistant_response = 1;
     */
    assistantResponse: string;
    /**
     * The assistant's structured response
     *
     * @generated from protobuf field: string structured_response = 2;
     */
    structuredResponse: string;
    /**
     * The type of structured response
     *
     * @generated from protobuf field: string structured_response_type = 3;
     */
    structuredResponseType: string;
    /**
     * Session ID identifying this conversation; pass back on subsequent turns.
     *
     * @generated from protobuf field: string conversation_id = 4;
     */
    conversationId: string;
}
/**
 * GeometryValue describes a collision geometry. As component context it is the current
 * shape (type is one of "none"/"box"/"sphere"/"capsule"). As a delta it is a partial
 * change: omit `type` to resize the current shape, set it to change shape (or "none" to
 * remove), and set only the dimensions that change. Dimensions are in millimeters.
 *
 * @generated from protobuf message inference.v1.GeometryValue
 */
export interface GeometryValue {
    /**
     * @generated from protobuf field: optional string type = 1;
     */
    type?: string;
    /**
     * @generated from protobuf field: optional double x = 2;
     */
    x?: number;
    /**
     * @generated from protobuf field: optional double y = 3;
     */
    y?: number;
    /**
     * @generated from protobuf field: optional double z = 4;
     */
    z?: number;
    /**
     * @generated from protobuf field: optional double r = 5;
     */
    r?: number;
    /**
     * @generated from protobuf field: optional double l = 6;
     */
    l?: number;
}
/**
 * ComponentFrameInput describes a single component's current frame for LLM context.
 *
 * @generated from protobuf message inference.v1.ComponentFrameInput
 */
export interface ComponentFrameInput {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string parent = 2;
     */
    parent: string;
    /**
     * @generated from protobuf field: double translation_x_mm = 3;
     */
    translationXMm: number;
    /**
     * @generated from protobuf field: double translation_y_mm = 4;
     */
    translationYMm: number;
    /**
     * @generated from protobuf field: double translation_z_mm = 5;
     */
    translationZMm: number;
    /**
     * @generated from protobuf field: double orientation_roll_deg = 6;
     */
    orientationRollDeg: number;
    /**
     * @generated from protobuf field: double orientation_pitch_deg = 7;
     */
    orientationPitchDeg: number;
    /**
     * @generated from protobuf field: double orientation_yaw_deg = 8;
     */
    orientationYawDeg: number;
    /**
     * @generated from protobuf field: optional inference.v1.GeometryValue geometry = 9;
     */
    geometry?: GeometryValue;
}
/**
 * FrameDeltaUpdate is a single LLM-proposed change to one component's frame.
 * Only fields the LLM intends to change are set; absent optional fields mean "leave unchanged".
 *
 * @generated from protobuf message inference.v1.FrameDeltaUpdate
 */
export interface FrameDeltaUpdate {
    /**
     * @generated from protobuf field: string component_name = 1;
     */
    componentName: string;
    /**
     * @generated from protobuf field: optional string parent = 2;
     */
    parent?: string;
    /**
     * @generated from protobuf field: optional double translation_x_mm = 3;
     */
    translationXMm?: number;
    /**
     * @generated from protobuf field: optional double translation_y_mm = 4;
     */
    translationYMm?: number;
    /**
     * @generated from protobuf field: optional double translation_z_mm = 5;
     */
    translationZMm?: number;
    /**
     * @generated from protobuf field: optional double orientation_roll_deg = 6;
     */
    orientationRollDeg?: number;
    /**
     * @generated from protobuf field: optional double orientation_pitch_deg = 7;
     */
    orientationPitchDeg?: number;
    /**
     * @generated from protobuf field: optional double orientation_yaw_deg = 8;
     */
    orientationYawDeg?: number;
    /**
     * @generated from protobuf field: string explanation = 9;
     */
    explanation: string;
    /**
     * @generated from protobuf field: optional inference.v1.GeometryValue geometry = 10;
     */
    geometry?: GeometryValue;
}
/**
 * @generated from protobuf message inference.v1.InferSceneUpdateRequest
 */
export interface InferSceneUpdateRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string prompt = 2;
     */
    prompt: string;
    /**
     * @generated from protobuf field: repeated inference.v1.ComponentFrameInput components = 3;
     */
    components: ComponentFrameInput[];
}
/**
 * @generated from protobuf message inference.v1.InferSceneUpdateResponse
 */
export interface InferSceneUpdateResponse {
    /**
     * @generated from protobuf field: repeated inference.v1.FrameDeltaUpdate updates = 1;
     */
    updates: FrameDeltaUpdate[];
    /**
     * @generated from protobuf field: string explanation = 2;
     */
    explanation: string;
    /**
     * Set only when the request cannot be fulfilled (e.g. adding or removing a component).
     *
     * @generated from protobuf field: optional string refusal = 3;
     */
    refusal?: string;
}
/**
 * @generated from protobuf enum inference.v1.ConversationRole
 */
export enum ConversationRole {
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: CONVERSATION_ROLE_ASSISTANT = 2;
     */
    ASSISTANT = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class InferQueryRequest$Type extends MessageType<InferQueryRequest> {
    constructor() {
        super("inference.v1.InferQueryRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_mql_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sample_documents", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "conversation_history", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "selected_tab", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "user_sql_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferQueryRequest
 */
export const InferQueryRequest = new InferQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferQueryResponse$Type extends MessageType<InferQueryResponse> {
    constructor() {
        super("inference.v1.InferQueryResponse", [
            { no: 1, name: "assistant_response", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "structured_response", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "structured_response_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferQueryResponse
 */
export const InferQueryResponse = new InferQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConversationTurn$Type extends MessageType<ConversationTurn> {
    constructor() {
        super("inference.v1.ConversationTurn", [
            { no: 1, name: "role", kind: "enum", T: () => ["inference.v1.ConversationRole", ConversationRole, "CONVERSATION_ROLE_"] },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.ConversationTurn
 */
export const ConversationTurn = new ConversationTurn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferModuleCodeRequest$Type extends MessageType<InferModuleCodeRequest> {
    constructor() {
        super("inference.v1.InferModuleCodeRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "module_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "code_content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "programming_language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "conversation_history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConversationTurn },
            { no: 7, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferModuleCodeRequest
 */
export const InferModuleCodeRequest = new InferModuleCodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferModuleCodeResponse$Type extends MessageType<InferModuleCodeResponse> {
    constructor() {
        super("inference.v1.InferModuleCodeResponse", [
            { no: 1, name: "assistant_response", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "structured_response", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "structured_response_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferModuleCodeResponse
 */
export const InferModuleCodeResponse = new InferModuleCodeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeometryValue$Type extends MessageType<GeometryValue> {
    constructor() {
        super("inference.v1.GeometryValue", [
            { no: 1, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "x", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "y", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "z", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "r", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "l", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.GeometryValue
 */
export const GeometryValue = new GeometryValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComponentFrameInput$Type extends MessageType<ComponentFrameInput> {
    constructor() {
        super("inference.v1.ComponentFrameInput", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "translation_x_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "translation_y_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "translation_z_mm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "orientation_roll_deg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "orientation_pitch_deg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "orientation_yaw_deg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "geometry", kind: "message", T: () => GeometryValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.ComponentFrameInput
 */
export const ComponentFrameInput = new ComponentFrameInput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FrameDeltaUpdate$Type extends MessageType<FrameDeltaUpdate> {
    constructor() {
        super("inference.v1.FrameDeltaUpdate", [
            { no: 1, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "parent", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "translation_x_mm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "translation_y_mm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "translation_z_mm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "orientation_roll_deg", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "orientation_pitch_deg", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "orientation_yaw_deg", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "geometry", kind: "message", T: () => GeometryValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.FrameDeltaUpdate
 */
export const FrameDeltaUpdate = new FrameDeltaUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferSceneUpdateRequest$Type extends MessageType<InferSceneUpdateRequest> {
    constructor() {
        super("inference.v1.InferSceneUpdateRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComponentFrameInput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferSceneUpdateRequest
 */
export const InferSceneUpdateRequest = new InferSceneUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferSceneUpdateResponse$Type extends MessageType<InferSceneUpdateResponse> {
    constructor() {
        super("inference.v1.InferSceneUpdateResponse", [
            { no: 1, name: "updates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FrameDeltaUpdate },
            { no: 2, name: "explanation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refusal", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message inference.v1.InferSceneUpdateResponse
 */
export const InferSceneUpdateResponse = new InferSceneUpdateResponse$Type();
/**
 * @generated ServiceType for protobuf service inference.v1.InferenceService
 */
export const InferenceService = new ServiceType("inference.v1.InferenceService", [
    { name: "InferQuery", options: {}, I: InferQueryRequest, O: InferQueryResponse },
    { name: "InferModuleCode", options: {}, I: InferModuleCodeRequest, O: InferModuleCodeResponse },
    { name: "InferSceneUpdate", options: {}, I: InferSceneUpdateRequest, O: InferSceneUpdateResponse }
]);
